<template>
  <section class="main-content">

    <section class="main-content__full section">
      <header class="section__header">
        <h1 class="section__title">Browse formats: {{ category.name }}</h1>
        <section class="section__header__area">
          <form class="search">
            <input-search placeholder="Search formats"></input-search>
          </form>
        </section>
      </header>
    </section>

    <aside class="main-content__side section">
      <categories-listing class="section__content categories"></categories-listing>
    </aside>

    <section class="main-content__main section">
      <h1 class="section__title">{{ category.name }}</h1>
      <br><br><br><br>
      <h1 class="section__subtitle">{{ category.description }}</h1>
      <br><br>
      <format-listing :formats=getFormats class="section__content formats formats--list"></format-listing>
    </section>
  </section>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'Category',
  mounted () {
    if (this.$route.params.id == 'invisible') {
      this.$store.dispatch('formats/loadAll');
    }
  },
  computed: {
    ...mapState('categories', ['categories']),
    ...mapState('users', ['favorites']),
    ...mapState(['account']),
    getFormats () {
      if (!this.category.formats) return;
      this.category.formats.sort((a, b) => {
        return a.sort - b.sort;
      });
      if (this.$route.params.id != 'invisible') {
        this.category.formats.filter(item => item.visible);
      }
      FS.event('Viewing Formats', {
        category_name_str: this.category.name,
        category_id: this.category.id
      });
      if (this.$store.state.formats.searchFilter) {
        return this.category.formats.filter(item => (item.name.toLowerCase().indexOf(this.$store.state.formats.searchFilter.toLowerCase()) > -1))
      } else {
        return this.category.formats
      }
    },
    category(){
      if (this.$route.params.id == 'favorites') {
        let rtnVal = {
          name: 'Favorites',
          formats: []
        }
        let formats = this.$store.getters['formats/formats']
        let favorites = this.favorites;
        if (formats && favorites) {
          formats.forEach(format => {
            favorites.forEach(favorite => {
              if (format.id === favorite.format_id) {
                rtnVal.formats.push(format);
              }
            })
          })
          return rtnVal
        }
      } else if (this.$route.params.id == 'recent') {
          let rtnVal = {
            name: 'Recently Released',
            formats: []
          }
          let formats = this.$store.getters['formats/formats']
          if (formats) {
            formats.forEach(format => {
              let today = new Date();
              if (new Date(format.updated_at) > new Date().setDate(today.getDate()-30)) {
                rtnVal.formats.push(format);
              }
            })
          }
          return rtnVal
      } else if (this.$route.params.id == 'custom') {
        let rtnVal = {
          name: '',
          formats: []
        }
        let accountFormats = this.$store.getters['formats/custom']
        if (accountFormats) {
          rtnVal.name = this.account.name + ' Premium';
          accountFormats.forEach(af => {
            rtnVal.formats.push(af);
          })
        }
        return rtnVal
      } else if (this.$route.params.id == 'invisible') {
        let rtnVal = {
          name: 'Non Public Ads',
          description: 'Ads that are not visible to the public consumer base.',
          formats: []
        };
        let accountFormats = this.$store.state.formats.allFormats;
        if (accountFormats) {
          accountFormats.forEach(af => {
            if (!af.visible) {
              rtnVal.formats.push(af);
            }
          });
          return rtnVal;
        }
      } else {
        const categoryId = parseInt(this.$route.params.id, 10);

        let category = this.categories.filter((category)=>{
          return categoryId === category.id
        })[0]

        return category ? category : {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Category.vue